import { PayOne } from '../global/payone.js';

export class Payment {
    constructor() {
        this.Payone = new PayOne();
        this.form = document.querySelector('#form-landingpage');
        this.clearingType = document.querySelector('#clearingType');
        this._creditcardHolder = document.querySelector('.payform-creditcard');
        this._pseudocardpan = document.querySelector('input[name="payment[pseudocardpan]"]');
        this.init();
    };
    
    init() {
        this.Payone.success = (response => {
            if(response.status == 'ok') {
                this._pseudocardpan.value = response.pseudocardpan;
            }
        });
    };
    
    getClearingType() {
        return this.clearingType.value;
    };
    
    initCreditCard() {
        this.Payone.initCreditCard((response) => {
            if(response.status == "ok") {
                let spinner = this._creditcardHolder.querySelector('.spinner');
                let loadholder = this._creditcardHolder.querySelector('.load-holder');
                
                if(spinner) {
                    spinner.classList.add('d-none');
                }
                if(loadholder) {
                    loadholder.classList.remove('d-none');
                }
            } else {
                this.disable('creditcard');
            }
        });
    };
};
